import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
// import { ConfirmDialogComponent } from 'app/utilerias/confirm-dialog/confirm-dialog.component';
// import { ConfirmDialogOpcionComponent } from 'app/utilerias/confirm-dialog-opcion/confirm-dialog-opcion.component';
// import { ConfirmDialogOkComponent } from 'app/utilerias/confirm-dialog-ok/confirm-dialog-ok.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { MostrarExcepcion, MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { sparrowService } from 'app/services/sparrowService';
import { SharedService } from 'app/shared.service';
import { ErrorFacturacionComponent } from 'app/modules/factura/error-facturacion/error-facturacion.component';
import { SuccessFacturacionComponent } from 'app/modules/factura/success-facturacion/success-facturacion.component';
import { Observable, zip } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { AppState, selectUtilsState } from 'app/store/app.states';
import { CoalService } from 'app/services/coal.service';
import { FerroviariosComponent } from '../ferroviarios/ferroviarios.component';
import { CatPais } from 'app/shared/enum.shared';

export interface DataRows {
    Acciones: number;
    Cantidad: number;
    Unidad: number;
    Concepto: number;
    PUnitario: number;
    SubTotal: number;
    Descuento: number;
    Total: number;
}
const DataRowsTable: DataRows[] = [];

@Component({
    selector: 'app-factura-cporte',
    templateUrl: './factura-cporte.component.html',
    styleUrls: ['./factura-cporte.component.scss']
})

export class FacturaCporteComponent implements OnInit {
    /**IMPUTUS OUTPUTS */
    @ViewChild(MatTable) table: MatTable<typeof DataRowsTable>;
    @ViewChild('ferroviariosRef') ferroviariosComponent: FerroviariosComponent;
    //@INPUTS
    @Input() tipo: any = 1;
    @Input() idOperacion: any;
    @Input() idFacturaEdit: any;
    //Listas formularios
    spinner = false;
    removeDisabledDomicilio: boolean = true;
    removeDisabledMercancia: boolean = true;
    removeDisabledTfigura: boolean = true;
    //Arreglos de formularios
    countDomicilio: any = [{ id: `Ubicacion 1` }, { id: `Ubicacion 2` }];
    countMercancia: any = [{ id: `Mercancia 1` }];
    countTfigura: any = [{ id: `Tipo Figura 1` }];
    //Arreglos para salvar listas
    ubicacioneslist = [];
    mercancialist = [];
    figuraslist = [];
    transportelist;

    Transportelist = [];
    idTransporte: number = 1;
    idPais: number = CatPais.Mexico;
    idMovimiento: number = 0;
    idMovimientoVias: number = 0;

    PTrasladolist:any[] = [];
    idPTraslado: number = 1;

    idFactura = null;
    lstProducto = [];

    Producto
    activarFrom = false;
    displayedColumns: string[] = ['Acciones', 'Cantidad', 'Unidad', 'Concepto', 'PUnitario', 'SubTotal', 'Descuento', 'Total'];
    //dataSource = new MatTableDataSource(DataRowsTable);

    addressChange: any;
    subtotal;
    total;
    descuento
    impuestosLocales: { nombre: string; tasa: number; monto: number; tipo: number; importeImpuesto: number; }[] = [];
    FormProducto = new FormGroup({
        cProducto: new FormControl(''),
        cUnidad: new FormControl(0),
        cantidad: new FormControl(0),
        precioUnitario: new FormControl(0),
        descuento: new FormControl(0),
        formaDescuento: new FormControl(0),
    });
    dataSource = [...DataRowsTable];
    UnidadPeso;
    idUbicacion;
    idMercancia;
    idTrasporte;
    idFiguras;
    idATransporte;
    idTransporteAereo;
    lstUnidadPeso: any[] = [];
    valoresFormulario: any;
    valoresFormularioAdicionales: any;
    accion;
    dataSourceAereos;
    dataTransporteAereo: any;
    dataSourceFerros: any;
    idUsuario: any = 2020;
    dataSourceMaritimo: any;
    idTransporteFerro: any;
    dataTransporteFerro: any;
    showTransInternacional: boolean = false;
    paisList: any;
    tipoMovimiento: any;
    movimientoVias: any;

    opcionesFiltradasUnidad: Observable<any[]>;
    unidadPeso = new FormControl('');

    idFerroviario: any;
    ferroviarios: any[];
    idEmpresa: number;
    idsDerechosPasos: any = []
    idsCarros: any = []

    //formPais = new FormGroup({
    paisInput = new FormControl('');
    // });
    paises: any[] = [];
    _filteredPais: Observable<any>;
    constructor(
        private readonly store: Store<AppState>,
        private router: Router,
        public dialog: MatDialog,
        private _snackBar: MatSnackBar,
        private srvcoal: CoalService,
        private sparroService: sparrowService,
        private sharedService: SharedService
    ) {
        this.store.select(selectUtilsState).subscribe((state: any) => {
            if (this.idEmpresa !== state.empresaSeleccionada.id) {
                this.idEmpresa = state.empresaSeleccionada.id;
            }
        });
    }

    async ngOnInit(): Promise<void> {
        await this.getDirPais();
        this.sharedService.idFactura$.subscribe(valores => {
            this.idFactura = valores;
            console.log('this.this.idFactura', this.idFactura)
        });
        this.sharedService.formulario$.subscribe(valores => {
            this.valoresFormulario = valores;
        });
        this.sharedService.Adicionalesformulario$.subscribe(valores => {
            // console.log('3 - Adicionalesformulario', valores)
            this.valoresFormularioAdicionales = valores;
        });
        this.sharedService.productoslist$.subscribe(valores => {
            // console.log(valores);
            this.dataSource = valores;
        });
        this.sharedService.aereosForm$.subscribe(valores => {
            this.dataSourceAereos = valores;
        });
        this.sharedService.ferroForm$.subscribe(valores => {
            this.dataSourceFerros = valores;
            console.log('this.dataSourceFerros', this.dataSourceFerros)
        });
        this.sharedService.maritimoForm$.subscribe(valores => {
            this.dataSourceMaritimo = valores;
            console.log('this.dataSourceMaritimo', this.dataSourceMaritimo)
        });

        this.sharedService.accion$.subscribe(valores => {
            this.accion = valores;
            switch (this.accion) {
                case 0:
                    console.log("Guardar");
                    this.InsFactrua();
                    break;
                case 1:
                    console.log("Borrador");
                    this.InsertarDatosComplemento();
                    //this.InsFactrua();
                    break;
                case 2:
                    console.log("Vista Previa");
                    this.vistaPrevia();
                    break;
                case 3:
                    console.log("Cancelar");
                    break;
                case 4:
                    console.log("Actualizar");
                    this.DelFactura();
                    break;
            }
        }); if (this.idFacturaEdit) {
            await this.selFactura();
        }

        // this.sharedService.trasladoPor$.subscribe( (valores:any) => {
        //    console.log(valores) 
        // });

        this.SelListasComplemento();
        await this.SelListasTraslado();
        //this.GetProducto();
        this.ubicacioneslist = [];
        this.mercancialist = [];
        this.figuraslist = [];
        this.transportelist = null;

        this.GetCatalogoImpuestos();

        let mexico = this.paises.find(x => x.id == CatPais.Mexico);
        this.paisInput.setValue(mexico || null);
        this._filteredPais = this.paisInput.valueChanges.pipe(
            startWith(''),
            map(value => {
                const name = typeof value === 'string' ? value : '';
                return name ? this._filterPais(name as string) : this.paises.slice();
            }),
        );

    }

    private _filterPais(value: string): any {
        const filterValue = value?.toLowerCase() || '';
        return this.paises.filter(option => option.attributes.idPais.toLowerCase().includes(filterValue) || option.attributes.nombre.toLowerCase().includes(filterValue));
    }

    displayFuncionPais(pais: any): string {
        if (pais?.attributes)
            return '' + pais?.attributes.idPais + ' - ' + pais?.attributes?.nombre;
        else
            return '';
    };

    changePais(value) {
        //console.log("🚀 ~ FacturaCporteComponent ~ changePais ~ value:", value)
        this.idPais = Number(value || 0);

    }
    changeTraslado() {
        this.sharedService.cambiarTraslado(this.idPTraslado)
    }

    changeTransporte() {
        console.log('1 - changeTransporte');
        this.sharedService.cambiarTransporte(this.idTransporte)
        if (this.idTransporte) {
            this.SelFerroviarios()
        }
    }
    changeTransporteInter(value) {
        console.log('changeTransporteInternacional', value);
        this.showTransInternacional = value//value ? true:false;
    }

    SelListasComplemento() {
        let data = {}
        this.store.dispatch(MostrarSpinner());
        zip(
            this.srvcoal.getService('cat-tipo-transportes'),
            this.srvcoal.getService('dir-paises'),
            this.srvcoal.getService('cat-tipo-movimientos'),
            this.srvcoal.getService('cat-movimiento-vias'),
        ).subscribe(
            (res: any) => {
                this.store.dispatch(OcultarSpinner());
                this.Transportelist = res[0]?.data;
                this.paisList = res[1]?.data;
                this.tipoMovimiento = res[2]?.data;
                this.movimientoVias = res[3]?.data;
            }, (error: any) => {
                this.store.dispatch(OcultarSpinner());
                this._snackBar.open("Ocurrió un error al obtener los datos", "OK", { duration: 5000 });
            }
        );
    }
    SelListasTraslado() :Promise<boolean>{
        return new Promise<boolean>(resolve => {
            this.store.dispatch(MostrarSpinner());
            this.srvcoal.getService('cat-forma-traslados?populate=*&pagination[start]=0&pagination[limit]=300').subscribe(
                (res: any) => {
                    console.log("🚀 ~ FacturaCporteComponent ~ SelListasTraslado:", res)
                    
                    this.store.dispatch(OcultarSpinner());
                    if (res.err) {
                        this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }));
                    } else if (res.excepcion) {
                        this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3, }));
                    } else {

                        this.PTrasladolist = res.data || [];

                    }
                    resolve(true)
                },
                (error: any) => {
                    this.store.dispatch(OcultarSpinner());
                    this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }));
                    resolve(false)
                }
            );

        });
     
    }

    GetProducto() {
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.getService(`catalogo/GetSelProductoGrid?idOperacion=${this.idOperacion}`,).subscribe((res: any) => {
            if (res.err) {
                this.store.dispatch(OcultarSpinner());
            } else if (res.excepcion) {
                this.store.dispatch(OcultarSpinner());
            } else {
                this.lstProducto = res.recordsets[0]
            };
        }, (error: any) => {
            this.store.dispatch(OcultarSpinner());
        });
    };

    addFormProducto() {
        this.activarFrom = true;
        this.FormProducto.controls.cProducto.setValue(this.Producto.claveProdServ);
        this.FormProducto.controls.cUnidad.setValue(this.Producto.codigoUnidad);
    }

    addProductoTable() {
        var total_neto;
        var total;
        var descuento = this.FormProducto.get('descuento').value;
        total = this.FormProducto.get('cantidad').value * this.FormProducto.get('precioUnitario').value;
        descuento = 0;
        total_neto = total;
        if (this.FormProducto.get('formaDescuento').value == 2) {
            total_neto = total - (total * (descuento / 100))
        } else {
            if (this.FormProducto.get('formaDescuento').value == 1) {
                total_neto = total - descuento;
            }
        }

        this.dataSource.push({
            Acciones: 1,
            Cantidad: this.FormProducto.get('cantidad').value,
            Unidad: this.FormProducto.get('cUnidad').value,
            Concepto: this.Producto.productoServicio,
            PUnitario: this.Producto.precioUnitario,
            SubTotal: total,
            Descuento: descuento,
            Total: total_neto
        });

        this.Producto = null;
        this.activarFrom = false;
        this.FormProducto.reset();
        this.table.renderRows();
    }

    addProductoFactura() {
        for (var i = 0; i <= this.dataSource.length - 1; i++) {
            this.insProductoFactur(this.dataSource[i]);
        }
        setTimeout(() => {
            this.timbrado();
        }, 4000);
    }

    timbrado() {
        let data = {
            idFactura: this.idFactura
        }
        this.srvcoal.postService('catalogo/PostTimbraTraslado', data).subscribe((res: any) => {
            if (res.err) {
                this.store.dispatch(
                    MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                );
            } else if (res.excepcion) {
                this.store.dispatch(
                    MostrarExcepcion({
                        pila: res.excepcion,
                        tipoExcepcion: 3,
                    })
                );
            } else {
                //registro exitoso

                if (res.recordsets[0][0].success === 1) {

                    var datafact = {
                        tipofactura: '',
                        clave: this.idFactura
                    }

                    this.openSuccess(res.recordsets[0][0], datafact);
                    this.router.navigateByUrl('/factura/facturas/0/0/0/0/0/0/0/0');

                    // var datafact = {
                    //     tipofactura: datosCliente.tipoFactura,
                    //     clave: res.recordsets[0][0].idFactura
                    // }

                    // this.openSuccess( res.recordsets[0][0], datafact );
                    this.store.dispatch(OcultarSpinner());
                }
                else {
                    this.openError(res.recordsets[0][0]);
                    this.store.dispatch(OcultarSpinner());
                }
            }
        },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            });
    }

    insProductoFactur(element) {
        let data = {
            descripcion: element.descripcion,
            precioUnitario: element.precio,
            idProducto: element.idProducto,
            ObjetoImpuesto: element.ObjetoImpuesto,
            idRol: 2,
            idOperacion: this.idOperacion,
            idFactura: this.idFactura,
            cantidad: element.cantidad,
            subtotal: element.subTotal,
            total: element.total,
            formaDescuento: element.formaDescuento,
            descuento: element.descuento
        }
        this.srvcoal.postService('catalogo/PostInsRelProductoFacturaComplemento', data).subscribe((res: any) => {
            if (res.err) {
                this.store.dispatch(
                    MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                );
            } else if (res.excepcion) {
                this.store.dispatch(
                    MostrarExcepcion({
                        pila: res.excepcion,
                        tipoExcepcion: 3,
                    })
                );
            } else {
                //registro exitoso
            }
        },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            });
    }
    //Funciones Factura
    InsFactrua() {
        console.log('this.idPTraslado', this.idPTraslado);
        let data = {
            idOperacion: this.idOperacion,
            idTtransporte: this.idTransporte,
            idPTranslado: this.idPTraslado,
            UnidadPeso: this.UnidadPeso.idUnidad,
            idVersionFactura: 1,
            idCliente: this.valoresFormulario.cliente,
            //
            tipoFactura: this.valoresFormulario.tipoFactura,
            lugarExpedicion: this.valoresFormulario.lugarExpedicion,
            formaPago: this.valoresFormulario.formaPago,
            serie: this.valoresFormulario.serie,
            metodoPago: this.valoresFormulario.metodoPago,

            numeroPedido: this.valoresFormularioAdicionales.numeroPedido,
            moneda: this.valoresFormularioAdicionales.moneda,
            tipoCambio: this.valoresFormularioAdicionales.tipoCambio,
            fechaEmision: this.valoresFormularioAdicionales.fechaEmision,
            numeroCuenta: this.valoresFormularioAdicionales.numerodeCuenta,
            nombreBanco: this.valoresFormularioAdicionales.nombreBanco,
            condicionesPago: this.valoresFormularioAdicionales.condicionesPago,
            observacion: this.valoresFormularioAdicionales.seleccionaObservacion === 0 ? null : this.valoresFormularioAdicionales.seleccionaObservacion,
            CFDIRelacionados: this.valoresFormularioAdicionales.cFDIRelacionado === 0 ? null : this.valoresFormularioAdicionales.cFDIRelacionado,
            cuentaBanco: this.valoresFormularioAdicionales.seleccioneCuentaBanco,
            observaciones: this.valoresFormularioAdicionales.observaciones,
            idRol: 2,
            idFactura: this.idFactura
        }
        this.srvcoal.postService('catalogo/PostInsFacturaCPorte', data).subscribe((res: any) => {
            if (res.err) {
                this.store.dispatch(
                    MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                );
            } else {
                // this.idFactura = res.recordsets[0][0].idRegistro;
                this.InsertarDatosComplemento();
                this.addProductoFactura();
                return this._snackBar.open("Registro Exitoso", 'Ok', { duration: 10000 });
            }
        },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            });
    }

    InsertarDatosComplemento() {
        switch (this.idTransporte) {
            //Insert transporte normal
            case 1:
                this.InsTransportes(this.transportelist);
                break;
            //Insert transporte aereo
            case 2:
                this.InsTransporteAereo();
                break;
            //Insert transporte ferroviario
            case 3:
                this.InsFerroviario();
                break;
            //Insert transporte maritimo
            case 4:
                this.InsMaritimo();
                break;
        }
        for (var i = 0; i <= this.ubicacioneslist.length - 1; i++) {
            this.InsDirecciones(this.ubicacioneslist[i]);
        }
        for (var i = 0; i <= this.mercancialist.length - 1; i++) {
            this.InsMercancias(this.mercancialist[i]);
        }
        for (var i = 0; i <= this.figuraslist.length - 1; i++) {
            this.InsFiguras(this.figuraslist[i]);
        }
    }

    InsFerroviario() {
        let parametros = {
            ...this.dataSourceFerros,
            idFactura: this.idFactura,
            idUsuario: this.idUsuario
        }
        this.srvcoal.postService('catalogo/PostInsFerroviaria', parametros).subscribe((res: any) => {
            if (res.err) {
                this.store.dispatch(
                    MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                );
            } else if (res.excepcion) {
                this.store.dispatch(
                    MostrarExcepcion({
                        pila: res.excepcion,
                        tipoExcepcion: 3,
                    })
                );
            } else {
                console.log('PostInsFerroviaria', res.recordsets)
            }
        },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            });
    }

    InsMaritimo() {
        let parametros = {
            ...this.dataSourceMaritimo,
            idFactura: this.idFactura,
            idUsuario: this.idUsuario
        }
        this.srvcoal.postService('catalogo/PostInsMaritimo', parametros).subscribe((res: any) => {
            if (res.err) {
                this.store.dispatch(
                    MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                );
            } else if (res.excepcion) {
                this.store.dispatch(
                    MostrarExcepcion({
                        pila: res.excepcion,
                        tipoExcepcion: 3,
                    })
                );
            } else {
                console.log('PostInsMaritimo', res.recordsets)
            }
        },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            });
    }

    InsDirecciones(element) {
        let data = {
            idFactura: this.idFactura,
            idDireccion: element.idubicacion
        }
        this.srvcoal.postService('catalogo/PostInsRelDireccion', data).subscribe((res: any) => {
            if (res.err) {
                this.store.dispatch(
                    MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                );
            } else if (res.excepcion) {
                this.store.dispatch(
                    MostrarExcepcion({
                        pila: res.excepcion,
                        tipoExcepcion: 3,
                    })
                );
            } else {

            }
        },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            });
    }

    InsMercancias(element) {
        let data = {
            idFactura: this.idFactura,
            idMercancia: element.idMercancia
        }
        this.srvcoal.postService('catalogo/PostInsRelMercancia', data).subscribe((res: any) => {
            if (res.err) {
                this.store.dispatch(
                    MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                );
            } else if (res.excepcion) {
                this.store.dispatch(
                    MostrarExcepcion({
                        pila: res.excepcion,
                        tipoExcepcion: 3,
                    })
                );
            } else {

            }
        },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            });
    }

    InsTransportes(element) {
        console.log('InsTransportes', element);
        let data = {
            idFactura: this.idFactura,
            idTransporte: element
        }
        this.srvcoal.postService('catalogo/PostInsRelTransporte', data).subscribe((res: any) => {
            if (res.err) {
                this.store.dispatch(
                    MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                );
            } else if (res.excepcion) {
                this.store.dispatch(
                    MostrarExcepcion({
                        pila: res.excepcion,
                        tipoExcepcion: 3,
                    })
                );
            } else {

            }
        },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            });
    }

    InsTransporteAereo() {
        let parametros = {
            ...this.dataSourceAereos,
            idFactura: this.idFactura
        }
        this.srvcoal.postService('catalogo/PostInsRelTransporteAereos', parametros).subscribe((res: any) => {
            if (res.err) {
                this.store.dispatch(
                    MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                );
            } else if (res.excepcion) {
                this.store.dispatch(
                    MostrarExcepcion({
                        pila: res.excepcion,
                        tipoExcepcion: 3,
                    })
                );
            } else {

            }
        },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            });
    }

    InsFiguras(element) {
        let data = {
            idFactura: this.idFactura,
            idFigura: element.idFigura
        }
        this.srvcoal.postService('catalogo/PostInsRelFiguras', data).subscribe((res: any) => {
            if (res.err) {
                this.store.dispatch(
                    MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                );
            } else if (res.excepcion) {
                this.store.dispatch(
                    MostrarExcepcion({
                        pila: res.excepcion,
                        tipoExcepcion: 3,
                    })
                );
            } else {

            }
        },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            });
    }

    DelFactura() {
        let data = {
            idFactura: this.idFactura
        }
        this.srvcoal.postService('catalogo/PostDelFacturaComplementoPorte', data).subscribe(async (res: any) => {
            if (res.err) {
                this.store.dispatch(
                    MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                );
            } else if (res.excepcion) {
                this.store.dispatch(
                    MostrarExcepcion({
                        pila: res.excepcion,
                        tipoExcepcion: 3,
                    })
                );
            } else {
                //await this.InsertarDatosComplemento();
                await this.InsFactrua();
            }
        },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            });
    }

    async UpdFactura() {
        this.idFactura = this.idFacturaEdit;
        await this.DelFactura();
    }

    selFactura() {
        let data = {
            idFactura: this.idFacturaEdit
        }
        this.srvcoal.postService('catalogo/PostSelFacturaComplementoPorte', data).subscribe((res: any) => {
            if (res.err) {
                this.store.dispatch(
                    MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                );
            } else if (res.excepcion) {
                this.store.dispatch(
                    MostrarExcepcion({
                        pila: res.excepcion,
                        tipoExcepcion: 3,
                    })
                );
            } else {
                this.idFactura = res.recordsets[0][0].idRegistro;
                this.idTransporte = res.recordsets[0][0].idTtransporte;
                this.idPTraslado = res.recordsets[0][0].idPTranslado;
                this.UnidadPeso = res.recordsets[0][0].idUnidadPeso;
                this.addDomicilioSel(res.recordsets[1]);
                this.addFiguraSel(res.recordsets[2]);
                this.addMercanciaSel(res.recordsets[3]);
                this.addATransporteSel(res.recordsets[4]);
                this.addAProductosSel(res.recordsets[5]);
                this.addTransporteAereo(res.recordsets[7]);
                this.addTransporteFerro(res.recordsets[8]);
            }
        },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            });
    }

    addDomicilioSel(data) {
        this.countDomicilio = [];
        for (var i = 0; i <= data?.length - 1; i++) {
            this.idUbicacion = data[i].idDireccion;
            this.addDomicilio();
        }
    }

    addMercanciaSel(data) {
        this.countMercancia = [];
        for (var i = 0; i <= data?.length - 1; i++) {
            this.idMercancia = data[i].idMercancia;
            this.addMercancia();
        }
    }

    addFiguraSel(data) {
        this.countTfigura = [];
        for (var i = 0; i <= data?.length - 1; i++) {
            this.idFiguras = data[i].idFigura;
            this.addTfigura();
        }
    }

    addATransporteSel(data) {
        if (data && data.length != 0) {
            this.idATransporte = data[0].idTransporte;
        }
    }

    addTransporteAereo(data) {
        if (data && data.length != 0) {
            this.idTransporteAereo = data[0].id;
            this.dataTransporteAereo = data[0]
        }
    }

    addTransporteFerro(data) {
        console.log('addTransporteFerro', data);
        if (data && data.length != 0) {
            this.idTransporteFerro = data[0].idFerroviaria;
            this.dataTransporteFerro = data[0]
        }
    }

    addAProductosSel(data) {
        this.dataSource = [];
        for (var i = 0; i <= data?.length - 1; i++) {
            this.dataSource.push({
                Acciones: 1,
                Cantidad: data[i].cantidad,
                Unidad: data[i].claveProdServ,
                Concepto: data[i].nombreInterno,
                PUnitario: data[i].precioUnitario,
                SubTotal: data[i].subtotal,
                Descuento: data[i].descuento,
                Total: data[i].total,
            });
        }
        try {
            this.table.renderRows();
        } catch (error) {
            console.log("Cant renderrwos");
        }
    }
    //Funciones para Domicilios
    //Agregar formulario
    addDomicilio = () => {
        this.countDomicilio.push({ id: `Ubicacion ${this.countDomicilio.length + 1}`, idUbicacion: this.idUbicacion });
        this.countDomicilio.length <= 2 ? this.removeDisabledDomicilio = true : this.removeDisabledDomicilio = false;

        if (this.countDomicilio.length >= 3) {
            this.sharedService.contarUbicaciones(true);
        }
        else {
            this.sharedService.contarUbicaciones(false);
        }

    };
    //Remover formulario
    removeDomicilio = () => {
        localStorage.removeItem('Ubicacion ' + this.countDomicilio.length);
        this.countDomicilio.splice(-1);
        this.countDomicilio.length <= 2 ? this.removeDisabledDomicilio = true : this.removeDisabledDomicilio = false;

        if (this.countDomicilio.length >= 3) {
            this.sharedService.contarUbicaciones(true);
        }
        else {
            this.sharedService.contarUbicaciones(false);
        }
    };
    //Agregar direcciones a la factura
    FormUbicacionEventEmiter = async (e) => {
        var bandera = false;
        if (this.ubicacioneslist.length > 0) {
            for (var i = 0; i <= this.ubicacioneslist.length - 1; i++) {
                if (this.ubicacioneslist[i].title == e.title) {
                    this.ubicacioneslist[i] = e;
                    bandera = true;
                }
            }
        }
        if (!bandera) {
            this.ubicacioneslist.push(e);
        }
    };


    //Funciones para mercancias
    //Agregar formulario
    addMercancia = () => {
        this.countMercancia.push({ id: `Mercancia ${this.countMercancia.length + 1}`, idMercancia: this.idMercancia });
        this.countMercancia.length <= 1 ? this.removeDisabledMercancia = true : this.removeDisabledMercancia = false;
    };

    //Remover formulario
    removeMercancia = () => {
        localStorage.removeItem('Mercancia ' + this.countMercancia.length);
        this.countMercancia.splice(-1);
        this.countMercancia.length <= 1 ? this.removeDisabledMercancia = true : this.removeDisabledMercancia = false;
    };

    FormMercanciaEventEmiter = async (e) => {
        var bandera = false;
        if (this.mercancialist.length > 0) {
            for (var i = 0; i <= this.mercancialist.length - 1; i++) {
                if (this.mercancialist[i].title == e.title) {
                    this.mercancialist[i] = e;
                    bandera = true;
                }
            }
        }
        if (!bandera) {
            this.mercancialist.push(e);
        }
    };

    //Funciones Tipos Figura
    //Agregar formulario
    addTfigura = () => {
        this.countTfigura.push({ id: `Tipo Figura ${this.countTfigura.length + 1}`, idFiguras: this.idFiguras });
        this.countTfigura.length <= 0 ? this.removeDisabledTfigura = true : this.removeDisabledTfigura = false;
    };

    //Remover formulario
    removeTfigura = () => {
        localStorage.removeItem('Tipo Figura ' + this.countTfigura.length);
        this.countTfigura.splice(-1);
        this.countTfigura.length <= 0 ? this.removeDisabledTfigura = true : this.removeDisabledTfigura = false;
    };

    FormFigurasEventEmiter = async (e) => {
        var bandera = false;
        if (this.figuraslist.length > 0) {
            for (var i = 0; i <= this.figuraslist.length - 1; i++) {
                if (this.figuraslist[i].title == e.title) {
                    this.figuraslist[i] = e;
                    bandera = true;
                }
            }
        }
        if (!bandera) {
            this.figuraslist.push(e);
        }
    };

    //Funciones Transportes
    //Agregar transporte a la factura
    FormTransporteEventEmiter = async (e) => {
        this.transportelist = e;
    };

    GetCatalogoImpuestos() {
        this.store.dispatch(MostrarSpinner());
        //&pagination[start]=0&pagination[limit]=54000
        this.srvcoal.getService(`cat-unidades?populate=*&pagination[start]=0&pagination[limit]=54000`,).subscribe((res: any) => {

            console.log("🚀 ~ FacturaCporteComponent ~ this.srvcoal.getService ~ GetCatalogoImpuestos:", res)
            if (res.err) {
                this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
            } else if (res.excepcion) {
                this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }))
            } else {
                this.lstUnidadPeso = res.data || [];
                this.opcionesFiltradasUnidad = this.unidadPeso.valueChanges.pipe(
                    startWith(''),
                    map(value => {
                        const name = typeof value === 'string' ? value : '';
                        return name ? this._filtrarUnidades(name as string) : this.lstUnidadPeso.slice();
                    })
                    //map(state => (state ? this._filtrarUnidades(state) : this.lstUnidadPeso.slice())),
                );
                if (this.idFacturaEdit) {
                    var UnidadPeso = this.UnidadPeso;
                    var objetoEncontrado = this.lstUnidadPeso.find(function (objeto) {
                        return parseInt(objeto.idUnidad) == UnidadPeso;
                    });
                    this.UnidadPeso = objetoEncontrado;


                }


            }
            this.store.dispatch(OcultarSpinner());
        }, (error: any) => {
            this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
            this.store.dispatch(OcultarSpinner())
        });
    }

    private _filtrarUnidades(value: any): any[] {
        try {
            const filterValue = value ? value.toLowerCase(): '';

            return this.lstUnidadPeso.filter(unidad =>
            (unidad?.attributes?.clave.toLowerCase().includes(filterValue) ||
                unidad?.attributes?.nombre?.toLowerCase().includes(filterValue))
            );
        } catch (e) {
            console.log(e)
        }
    }

    displayFn = (unidad: any): string => {
        const unidadEncontrada = this.lstUnidadPeso.find((f: any) => f.id === unidad);
        if (unidadEncontrada) {
            return `${unidadEncontrada.attributes.clave} - ${unidadEncontrada.attributes.nombre}`;
        } else {
            return '';
        }
    }
    //Vista previa
    //Descargar PDF
    async vistaPrevia() {
        if (this.idFacturaEdit) {
            this.facturaComplementoPago();
        } else {
            // var tempData = //await this.facturaComplementoPagoPreviaData();
            // console.log("Data temp");
            // console.log(tempData);
            let data = [
                //Receptor
                [
                    {
                        "a": "Receptor",
                        "fullname": "  ",
                        "rfc": "SCO190723UU7",
                        "direccion": "DE LA YUNTA 70, 2178, CP.52945, Atizapán de Zaragoza, México, México",
                        "LugarEmosion": "Atizapan"
                    }
                ],
                //Emisor
                [
                    {
                        "rfc": "CSO180718BU0",
                        "nombreRazonSocial": "COAL SOLUTIONS",
                        "direccion": "DE LA YUNTA 70, 2178, CP.52945, Atizapán de Zaragoza, México, México"
                    }
                ],
                //Datos vacios
                [],
                //Datos Factura
                [
                    {
                        "idFactura": 2675,
                        "serie": null,
                        "folio": null,
                        "idRol": 2,
                        "idOperacion": 2017,
                        "idCliente": 2063,
                        "idVersionFactura": 1,
                        "idTipoFactura": 10,
                        "activo": true,
                        "fechaRegistro": "2023-05-22T03:48:33.440Z",
                        "fechaActualizacion": null,
                        "usuarioRegistro": 2020,
                        "usuarioActualizacion": null,
                        "transporte": "Auto Transporte",
                        "traslado": "Propios medios(Traslado)"
                    }
                ],
                //Direcciones
                [
                    {
                        "nombre": "ORIGEN02",
                        "pais": "México",
                        "estado": "Morelos",
                        "municipio": "Jiutepec",
                        "calle": "asd",
                        "numero": "1",
                        "cp": "62570"
                    },
                    {
                        "nombre": "ORIGEN02",
                        "pais": "México",
                        "estado": "Morelos",
                        "municipio": "Jiutepec",
                        "calle": "asd",
                        "numero": "1",
                        "cp": "62570"
                    },
                    {
                        "nombre": "DESTINO02",
                        "pais": "México",
                        "estado": "Morelos",
                        "municipio": "Jiutepec",
                        "calle": "asd",
                        "numero": "1",
                        "cp": "62570"
                    },
                    {
                        "nombre": "DESTINO02",
                        "pais": "México",
                        "estado": "Morelos",
                        "municipio": "Jiutepec",
                        "calle": "asd",
                        "numero": "1",
                        "cp": "62570"
                    }
                ],
                //Mercancias
                [
                    {
                        "nombre": "Darien test Merc",
                        "cantBienes": 1,
                        "claveBienes": "asd",
                        "descripcionBienes": "asd",
                        "cUnidad": "asd",
                        "unidad": "dasd"
                    },
                    {
                        "nombre": "Darien test Merc",
                        "cantBienes": 1,
                        "claveBienes": "asd",
                        "descripcionBienes": "asd",
                        "cUnidad": "asd",
                        "unidad": "dasd"
                    }
                ],
                //Fuia transporte
                [],
                //Guia identificacion
                [],
                //Auto Transporte
                [
                    {
                        "nombre": "asd",
                        "NumPermisoSCT": "asd",
                        "PermSCT": "asd",
                        "ConfigVehicular": "123",
                        "AseguraRespCivil": "13"
                    },
                    {
                        "nombre": "asd",
                        "NumPermisoSCT": "asd",
                        "PermSCT": "asd",
                        "ConfigVehicular": "123",
                        "AseguraRespCivil": "13"
                    }
                ],
                //Figuras
                [
                    {
                        "nombre": "asd",
                        "tipo": "Operador",
                        "RFCFigura": "123",
                        "ResidenciaFiscalFigura": "143",
                        "NumRegIdTribFigura": "",
                        "NumLicencia": "123"
                    },
                    {
                        "nombre": "NOMBRE FIG",
                        "tipo": "Operador",
                        "RFCFigura": "RFCFIG",
                        "ResidenciaFiscalFigura": "2",
                        "NumRegIdTribFigura": "",
                        "NumLicencia": "987"
                    }
                ],
                //Pagos
                [],
                [
                    {
                        "subtotal": null,
                        "total": null
                    }
                ]
            ]
            this.sparroService.getReport("reportes/CallFeatureNewComplementoPorte", data, "Test Reporte");
        }

    }

    facturaComplementoPago() {
        var data;
        var body = { idFactura: this.idFacturaEdit }
        this.srvcoal.postService(`catalogo/SelComplementoPorteFactrua`, body).subscribe((res: any) => {
            if (res.err) {
                this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
            } else if (res.excepcion) {
                this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }))
            } else {
                data = res.recordsets;
                this.sparroService.getReport("reportes/CallFeatureNewComplementoPorte", data, "Test Reporte");
            }
            this.store.dispatch(OcultarSpinner());
        }, (error: any) => {
            this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
            this.store.dispatch(OcultarSpinner())
        });
    }

    // facturaComplementoPagoPreviaData(){
    //     var data;
    //     var body = {
    //         ubicacioneslist     : this.ubicacioneslist.map(ubicacion => ubicacion.idubicacion).join(','),
    //         mercancialist       : this.mercancialist.map(mercancia => mercancia.idMercancia).join(','),
    //         figuraslist         : this.figuraslist.map(figura => figura.idFigura).join(','),
    //         transportelist      : this.transportelist,
    //         idreceptor          : this.valoresFormulario.cliente,
    //         idoperacion         : this.idOperacion
    //     }
    //     this.srvcoal.postService(`catalogo/SelComplementoPorteFactruaPrevia`,body).subscribe((res: any) => {
    //         if (res.err) {
    //             this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
    //         } else if (res.excepcion) {
    //             this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }))
    //         } else {
    //             data = res.recordsets;

    //         }
    //         this.store.dispatch(OcultarSpinner());
    //         }, (error: any) => {
    //         this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
    //         this.store.dispatch(OcultarSpinner())
    //     });
    // }

    openError(error) {
        const dialogRef = this.dialog.open(ErrorFacturacionComponent, {
            width: '60%',
            data: { error: error }
        });

        dialogRef.afterClosed().subscribe(result => {

        });
    }

    openSuccess(respuesta, data) {
        const dialogRef = this.dialog.open(SuccessFacturacionComponent, {
            width: '60%',
            data: { error: respuesta, data: data }
        });

        dialogRef.afterClosed().subscribe(result => {

        });
    }

    saveFerroviario(e: any) {
        console.log(e)

        if (e.formTransporte.valid) {


            let bodyTransporte = {
                data: {
                    cat_tipo_servicio: e.formTransporte.get('servicio').value,
                    nombreAseg: e.formTransporte.get('nombre').value,
                    numPolizaSeguro: e.formTransporte.get('poliza').value,
                    Concesionario: e.formTransporte.get('concecionario').value,

                    fac_porte_derechos: null,
                    fac_porte_carros: null
                }
            };
            this.idFerroviario = e.idFerroviario
            if (this.idFerroviario !== '' && this.idFerroviario !== undefined) {
                this.srvcoal.putService(`fac-porte-ferroviarios/${this.idFerroviario}`, bodyTransporte).subscribe(async (res: any) => {
                    if (res.err) {
                        this.store.dispatch(
                            MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                        );
                    } else if (res.excepcion) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.excepcion,
                                tipoExcepcion: 3,
                            })
                        );
                    } else {

                        const pasos = e.formTransporte.get('datosPaso').value
                        const carros = e.formTransporte.get('datosCarro').value

                        this.insExtras(pasos, carros);

                        return this._snackBar.open("Registro Exitoso", 'Ok', { duration: 10000 });
                    }
                },
                    (error: any) => {
                        this.store.dispatch(
                            MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                        );
                        this.store.dispatch(OcultarSpinner());
                    });

            } else {
                this.srvcoal.postService('fac-porte-ferroviarios', bodyTransporte).subscribe(async (res: any) => {
                    if (res.err) {
                        this.store.dispatch(
                            MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                        );
                    } else if (res.excepcion) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.excepcion,
                                tipoExcepcion: 3,
                            })
                        );
                    } else {

                        this.idFerroviario = res.data.id;

                        const pasos = e.formTransporte.get('datosPaso').value
                        const carros = e.formTransporte.get('datosCarro').value

                        this.insExtras(pasos, carros);

                        const idTransportes = []

                        this.ferroviarios.forEach(element => {
                            idTransportes.push(element.id)
                        });

                        idTransportes.push(this.idFerroviario)

                        const bodyActualizacion = {
                            fac_porte_ferroviarios: idTransportes
                        }
                        this.srvcoal.putService(`ope-empresas/${this.idEmpresa}`, { data: bodyActualizacion }).subscribe(
                            (res3: any) => {
                                if (!res3.err) {
                                    this.SelFerroviarios()
                                }
                            },
                            (error) => {
                            }
                        );



                        return this._snackBar.open("Registro Exitoso", 'Ok', { duration: 10000 });
                    }
                },
                    (error: any) => {
                        this.store.dispatch(
                            MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                        );
                        this.store.dispatch(OcultarSpinner());
                    });
            }
        }
    }

    delFerroviario(e: any) {

        let body = {
            data: {
                publishedAt: null
            }
        }
        const idFerroviario = e

        this.srvcoal.putService(`fac-porte-ferroviarios/${idFerroviario}`, body).subscribe(async (res: any) => {
            if (res.err) {
                this.store.dispatch(
                    MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                );
            } else if (res.excepcion) {
                this.store.dispatch(
                    MostrarExcepcion({
                        pila: res.excepcion,
                        tipoExcepcion: 3,
                    })
                );
            } else {
                this.SelFerroviarios();
                return this._snackBar.open("Eliminacion Exitoso", 'Ok', { duration: 10000 });
            }
        },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            });
    }

    resetFormulario(e: any) {
        this.idFerroviario = null;
        this.SelFerroviarios();
    }

    SelFerroviarios() {

        this.srvcoal.getService(`ope-empresas?filters[id]=${this.idEmpresa}
        &populate[fac_porte_ferroviarios][populate][cat_tipo_servicio][populate]=*
        &populate[fac_porte_ferroviarios][populate][fac_porte_derechos][populate]=cat_tipo_derecho_paso
        &populate[fac_porte_ferroviarios][populate][fac_porte_carros][populate]=cat_tipo_carro
        &populate[fac_porte_ferroviarios][populate][fac_porte_carros][populate]=fac_porte_contenedor.cat_tipo_contenedor`).subscribe(async (res: any) => {

            if (res.err) {
                this.store.dispatch(
                    MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                );
            } else if (res.excepcion) {
                this.store.dispatch(
                    MostrarExcepcion({
                        pila: res.excepcion,
                        tipoExcepcion: 3,
                    })
                );
            } else {
                this.ferroviarios = res.data[0].attributes.fac_porte_ferroviarios.data;
                if (this.idFerroviario) {
                    for (let i = 0; i <= this.ferroviarios.length - 1; i++) {
                        console.log(this.ferroviarios)
                        var ubicacion = this.ferroviarios[i].id;
                        console.log(ubicacion, this.idMercancia)
                        if (ubicacion == this.idFerroviario) {
                            console.log(this.ferroviarios[i])
                            this.ferroviariosComponent.AsignarValor(this.ferroviarios[i])

                            break;
                        }

                    }

                }

            }
        },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            });
    }

    insExtras(pasos: any, carros: any) {
        pasos.forEach(paso => {
            this.insPaso(paso);
        });

        carros.forEach(carro => {
            this.insCarro(carro);
        });

    }

    insPaso(paso: any) {
        let body = {
            data: {
                cat_tipo_derecho_paso: paso.TipoDerechoDePaso,
                KilometrajePagado: Number(paso.KilometrajePagado),
            }
        }
        this.srvcoal.postService('fac-porte-derechos', body).subscribe((res: any) => {
            if (res.err) {
                this.store.dispatch(
                    MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                );
            } else if (res.excepcion) {
                this.store.dispatch(
                    MostrarExcepcion({
                        pila: res.excepcion,
                        tipoExcepcion: 3,
                    })
                );
            } else {
                const id: any = res.data.id
                this.idsDerechosPasos.push(id)
                let bodyActualizaDerechosPasos = {
                    data: {
                        fac_porte_derechos: this.idsDerechosPasos
                    }

                }
                this.srvcoal.putService(`fac-porte-ferroviarios/${this.idFerroviario}`, bodyActualizaDerechosPasos).subscribe(async (res: any) => {
                    if (res.err) {
                        this.store.dispatch(
                            MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                        );
                    } else if (res.excepcion) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.excepcion,
                                tipoExcepcion: 3,
                            })
                        );
                    } else {


                    }
                },
                    (error: any) => {
                        this.store.dispatch(
                            MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                        );
                        this.store.dispatch(OcultarSpinner());
                    });
            }
        },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            });
    }

    insCarro(carro: any) {
        let body = {
            data: {
                cat_tipo_carro: carro.TipoCarro,
                matriculaCarro: carro.MatriculaCarro,
                guiaCarro: carro.GuiaCarro,
                toneladasNetasCarro: carro.ToneladasNetasCarro,
                fac_porte_contenedor: null
            }
        }
        this.srvcoal.postService('fac-porte-carros', body).subscribe((res: any) => {
            if (res.err) {
                this.store.dispatch(
                    MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                );
            } else if (res.excepcion) {
                this.store.dispatch(
                    MostrarExcepcion({
                        pila: res.excepcion,
                        tipoExcepcion: 3,
                    })
                );
            } else {
                const id: any = res.data.id

                carro.Contenedor.forEach(element => {
                    this.InsContenedor(element, id)
                });

                this.idsCarros.push(id)
                let bodyActualizaCarros = {
                    data: {
                        fac_porte_carros: this.idsCarros
                    }

                }
                this.srvcoal.putService(`fac-porte-ferroviarios/${this.idFerroviario}`, bodyActualizaCarros).subscribe(async (res: any) => {
                    if (res.err) {
                        this.store.dispatch(
                            MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                        );
                    } else if (res.excepcion) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.excepcion,
                                tipoExcepcion: 3,
                            })
                        );
                    } else {


                    }
                },
                    (error: any) => {
                        this.store.dispatch(
                            MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                        );
                        this.store.dispatch(OcultarSpinner());
                    });
            }
        },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            });
    }

    InsContenedor(contenedor, idCarro) {
        let body = {
            data: {
                cat_tipo_contenedor: contenedor.TipoContenedor,
                pesoContenedorVacio: contenedor.PesoContenedorVacio,
                pesoNetoMercancia: contenedor.PesoNetoMercancia
            }
        }

        let idContenedores = []
        this.srvcoal.postService('fac-porte-contenedores', body).subscribe((res: any) => {
            if (res.err) {
                this.store.dispatch(
                    MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                );
            } else if (res.excepcion) {
                this.store.dispatch(
                    MostrarExcepcion({
                        pila: res.excepcion,
                        tipoExcepcion: 3,
                    })
                );
            } else {
                const idContenedor: any = res.data.id

                idContenedores.push(idContenedor)
                let bodyActualizaContenedores = {
                    data: {
                        fac_porte_contenedor: idContenedores
                    }

                }
                this.srvcoal.putService(`fac-porte-carros/${idCarro}`, bodyActualizaContenedores).subscribe(async (res: any) => {
                    if (res.err) {
                        this.store.dispatch(
                            MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                        );
                    } else if (res.excepcion) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.excepcion,
                                tipoExcepcion: 3,
                            })
                        );
                    } else {


                    }
                },
                    (error: any) => {
                        this.store.dispatch(
                            MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                        );
                        this.store.dispatch(OcultarSpinner());
                    });
            }
        },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            });

    }


    AddressEmitter(event) {
        this.addressChange = event;
    }

    changeEntradaSal() {
    }

    changeViaEntrada() {
    }

    getDirPais(): Promise<boolean> {

        return new Promise<boolean>(resolve => {
            this.store.dispatch(MostrarSpinner());
            this.srvcoal.getService('dir-paises?populate=*&pagination[start]=0&pagination[limit]=300').subscribe(
                (res: any) => {
                    //console.log("🚀 ~ FacturaCporteComponent ~ getDirPais ~ res:", res)
                    this.store.dispatch(OcultarSpinner());
                    if (res.err) {
                        this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }));
                    } else if (res.excepcion) {
                        this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3, }));
                    } else {

                        this.paises = res.data || [];

                    }
                    resolve(true)
                },
                (error: any) => {
                    this.store.dispatch(OcultarSpinner());
                    this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }));
                    resolve(false)
                }
            );

        });

    }

}
